 import React from 'react'
import { useEffect, useState, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import { isEmpty, getglobaldata, CellType, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, NumConv, isEnabled, isNumber } from '../modules/appLibrary';
import { styled } from '@material-ui/core/styles';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption } from '../modules/formstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const CompleteProc = props => {

    const panelsdef = [];
    const formid = getformid("CompleteProc", props.location.search);
    const controller = getcontroller("CompleteProc", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const menuinfo = useSelector(state => state.form.menuinfo);

    const fnc = useRef();

    //データ
    const entrydataRef = useRef(null);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const ComFunc = React.forwardRef(ComFunction);


    const actionurl = {
        "update": "CompleteProc/Update",
        "getlist": "CompleteProc/GetListData",
    }

    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
    ]

    const masterBaseRef = useRef(null);

    useEffect(() => {
        masterBaseRef.current?.hideMenucmd([
            { status: "UPDATE", cmd: "削除" }
        ]);
    }, []);

    function Listlockcell(e) {
        if (e.status !== 'UPDATE' && !isEmpty(e.status)) return;
        if (e.colDef.colId !== "SSD_FIXFLG") return;
        //完納状態が06:完納済み 07:DS完納の場合編集不可
        if (e.data["SSD_KANNOSTATUS"] === "06" || e.data["SSD_KANNOSTATUS"] === "07") return false;
        else return true;
    }

    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                ref={masterBaseRef}
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                tabs={true}
                lockcell={Listlockcell}
                navmenu={navmenu}
                entrydataRef={entrydataRef}
                usecondition={true}
            >
            </MasterBase>
        </div>
    );
};


